// Cross-tab auth synchronization channel.
//
// Problem this solves:
// Backend revokes the previous access token whenever a refresh succeeds. So
// when a second tab boots and runs PersistLogin -> refresh, the first tab's
// in-memory access token becomes invalid (gets 443 on the next request).
//
// All tabs of this app share this channel and broadcast whenever auth state
// changes (refresh / logout). Listeners update their own AuthContext so every
// tab ends up holding the same currently-valid access token.

const CHANNEL_NAME = "mk-backoffice-auth";

const authChannel =
  typeof BroadcastChannel !== "undefined"
    ? new BroadcastChannel(CHANNEL_NAME)
    : null;

export const AUTH_CHANNEL_EVENTS = {
  AUTH_UPDATED: "AUTH_UPDATED",
  AUTH_CLEARED: "AUTH_CLEARED",
};

export const broadcastAuthUpdated = (auth) => {
  authChannel?.postMessage({ type: AUTH_CHANNEL_EVENTS.AUTH_UPDATED, auth });
};

export const broadcastAuthCleared = () => {
  authChannel?.postMessage({ type: AUTH_CHANNEL_EVENTS.AUTH_CLEARED });
};

export default authChannel;
